import { labelSubscribersPaginationTransform } from 'graphql/transforms';
import { useEffect, useMemo } from 'react';
import { useQuery } from 'urql';
import { GetLabelSubscribers } from './graphql';
import { useLabelSubscribersContext } from './LabelSubscribersContext';

function useQueryLabelSubscribers(page: number) {
  const {
    setFetching,
    perPage,
    isSmallScreen,
    setError,
    setPageInfo,
    filterBy,
    sortBy,
    label
  } = useLabelSubscribersContext();

  useMemo(
    () => ({
      label,
      filterBy,
      sortBy
    }),
    [label, filterBy, sortBy]
  );

  const [{ data, error, fetching, stale }] = useQuery({
    query: GetLabelSubscribers,
    requestPolicy: 'cache-and-network',
    variables: {
      page,
      perPage: isSmallScreen ? 20 : perPage,
      labelId: label.id,
      filterBy,
      sortBy
    }
  });

  // TODO: Remove stale check once we switch to a new query/caching tool
  // URQL's graphecache will set fetching false when there is partial data and is not reliable.
  const loading = fetching || (stale && data?.label?.subscribers === null);

  const { data: subscribers, pageInfo } = labelSubscribersPaginationTransform(data);

  // Here we are watching useQuery and updating our LabelSubscriber context accordingly
  useEffect(() => {
    if (page === pageInfo.page) setPageInfo(pageInfo);
  }, [page, pageInfo, setPageInfo]);

  useEffect(() => {
    setFetching(loading);
  }, [loading, setFetching]);

  useEffect(() => {
    if (error !== undefined) setError(error);
  }, [error, setError]);

  return { data: subscribers, error, fetching: loading, pageInfo };
}

export default useQueryLabelSubscribers;
